import { render, staticRenderFns } from "./ManageFouroverStatus.vue?vue&type=template&id=b0f24ca8"
import script from "./ManageFouroverStatus.vue?vue&type=script&lang=js"
export * from "./ManageFouroverStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports